import { render, staticRenderFns } from "./cadastro_novo_assistente.vue?vue&type=template&id=6d3a8776&scoped=true&"
import script from "./cadastro_novo_assistente.vue?vue&type=script&lang=js&"
export * from "./cadastro_novo_assistente.vue?vue&type=script&lang=js&"
import style0 from "./cadastro_novo_assistente.vue?vue&type=style&index=0&id=6d3a8776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a8776",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCombobox,VProgressCircular,VRadio,VRadioGroup,VSelect,VTextField})
